import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

interface VideoProps {
  title: string;
  url: string;
  thumbnail?: string;
  category: string;
  description?: string;
}

const CraftyCreationsPage = () => {
  const [activeVideo, setActiveVideo] = useState<VideoProps | null>(null);
  
  const videos: VideoProps[] = [
    // Fish
    {
      title: "Peixes Coloridos",
      url: "https://www.youtube.com/shorts/j1f2FZezNF4",
      thumbnail: "https://i.ytimg.com/vi/j1f2FZezNF4/hqdefault.jpg",
      category: "fish",
      description: "Peixes coloridos nadando em águas cristalinas"
    },
    {
      title: "Cardume de Peixes",
      url: "https://www.youtube.com/shorts/yBS6B-LS8bM",
      thumbnail: "https://i.ytimg.com/vi/yBS6B-LS8bM/hqdefault.jpg",
      category: "fish",
      description: "Cardume de peixes nadando em sincronia"
    },
    {
      title: "Peixes Tropicais",
      url: "https://www.youtube.com/shorts/ISxEcYSF4jA",
      thumbnail: "https://i.ytimg.com/vi/ISxEcYSF4jA/hqdefault.jpg",
      category: "fish",
      description: "Peixes tropicais em recifes de coral"
    },
    {
      title: "Peixes Exóticos",
      url: "https://www.youtube.com/shorts/_zMVI5nE1VI",
      thumbnail: "https://i.ytimg.com/vi/_zMVI5nE1VI/hqdefault.jpg",
      category: "fish",
      description: "Espécies exóticas de peixes em seu habitat natural"
    },
    {
      title: "Peixe Palhaço",
      url: "https://www.youtube.com/shorts/ifYxjOpXaTU",
      thumbnail: "https://i.ytimg.com/vi/ifYxjOpXaTU/hqdefault.jpg",
      category: "fish",
      description: "Peixes palhaço em recifes de coral"
    },
    
    // Dogs
    {
      title: "Cachorro Brincando",
      url: "https://www.youtube.com/shorts/QAB5vxit8iU",
      thumbnail: "https://i.ytimg.com/vi/QAB5vxit8iU/hqdefault.jpg",
      category: "dog",
      description: "Cachorro brincando no parque"
    },
    {
      title: "Filhote de Cachorro",
      url: "https://www.youtube.com/shorts/qTkLXhZ7NvI",
      thumbnail: "https://i.ytimg.com/vi/qTkLXhZ7NvI/hqdefault.jpg",
      category: "dog",
      description: "Filhote de cachorro explorando o mundo"
    },
    
    // Butterflies
    {
      title: "Borboletas Coloridas",
      url: "https://www.youtube.com/shorts/mfqwg2oMM1k",
      thumbnail: "https://i.ytimg.com/vi/mfqwg2oMM1k/hqdefault.jpg",
      category: "butterfly",
      description: "Borboletas coloridas voando entre flores"
    },
    
    // Owls
    {
      title: "Coruja Majestosa",
      url: "https://www.youtube.com/shorts/-cVG9VNkXgI",
      thumbnail: "https://i.ytimg.com/vi/-cVG9VNkXgI/hqdefault.jpg",
      category: "owl",
      description: "Coruja observando atentamente a paisagem"
    },
    
    // Hippos
    {
      title: "Hipopótamo na Água",
      url: "https://www.youtube.com/shorts/i4XwCFoTMFA",
      thumbnail: "https://i.ytimg.com/vi/i4XwCFoTMFA/hqdefault.jpg",
      category: "hippo",
      description: "Hipopótamo refrescando-se na água"
    },
    
    // Octopus
    {
      title: "Polvo Inteligente",
      url: "https://www.youtube.com/shorts/KvF-9TpG-aY",
      thumbnail: "https://i.ytimg.com/vi/KvF-9TpG-aY/hqdefault.jpg",
      category: "octopus",
      description: "Polvo demonstrando sua incrível inteligência"
    },
    
    // Scorpions
    {
      title: "Escorpião Noturno",
      url: "https://www.youtube.com/shorts/QPN4qHGgMm8",
      thumbnail: "https://i.ytimg.com/vi/QPN4qHGgMm8/hqdefault.jpg",
      category: "scorpion",
      description: "Escorpião em seu habitat natural"
    },
    
    // Rats
    {
      title: "Rato Curioso",
      url: "https://youtube.com/shorts/5bWKW3EEWbw",
      thumbnail: "https://i.ytimg.com/vi/5bWKW3EEWbw/hqdefault.jpg",
      category: "rat",
      description: "Rato explorando seu ambiente"
    },
    
    // Zebras
    {
      title: "Zebra na Savana",
      url: "https://www.youtube.com/watch?v=RlROA49MCO4",
      thumbnail: "https://i.ytimg.com/vi/RlROA49MCO4/hqdefault.jpg",
      category: "zebra",
      description: "Zebras pastando na savana africana"
    },
    
    // Horses
    {
      title: "Cavalo Selvagem",
      url: "https://www.youtube.com/watch?v=jHId-o7Rkss",
      thumbnail: "https://i.ytimg.com/vi/jHId-o7Rkss/hqdefault.jpg",
      category: "horse",
      description: "Cavalos selvagens correndo livremente"
    },
    
    // Foxes
    {
      title: "Raposa Astuta",
      url: "https://www.youtube.com/watch?v=TbVzIIFieE4",
      thumbnail: "https://i.ytimg.com/vi/TbVzIIFieE4/hqdefault.jpg",
      category: "fox",
      description: "Raposa explorando a floresta"
    },
    
    // Cats
    {
      title: "Gato Brincalhão",
      url: "https://www.youtube.com/watch?v=bbqEau-DY84",
      thumbnail: "https://i.ytimg.com/vi/bbqEau-DY84/hqdefault.jpg",
      category: "cat",
      description: "Gato brincando com um brinquedo"
    },
    {
      title: "Gato Dormindo",
      url: "https://www.youtube.com/watch?v=hyb7EM5NhrU",
      thumbnail: "https://i.ytimg.com/vi/hyb7EM5NhrU/hqdefault.jpg",
      category: "cat",
      description: "Gato dormindo tranquilamente"
    },
    
    // Ducks
    {
      title: "Pato Nadando",
      url: "https://www.youtube.com/watch?v=zouzrTn6ZWU",
      thumbnail: "https://i.ytimg.com/vi/zouzrTn6ZWU/hqdefault.jpg",
      category: "duck",
      description: "Pato nadando em um lago tranquilo"
    },
    
    // Food
    {
      title: "Abacaxi Suculento",
      url: "https://www.youtube.com/shorts/ifq4N7kJ2Xw",
      thumbnail: "https://i.ytimg.com/vi/ifq4N7kJ2Xw/hqdefault.jpg",
      category: "food",
      description: "Abacaxi fresco e suculento"
    },
    {
      title: "Preparando Abacaxi",
      url: "https://www.youtube.com/watch?v=Tmvjn-DV0uk",
      thumbnail: "https://i.ytimg.com/vi/Tmvjn-DV0uk/hqdefault.jpg",
      category: "food",
      description: "Como preparar abacaxi perfeitamente"
    },
    {
      title: "Receita de Abacaxi",
      url: "https://www.youtube.com/watch?v=yLRzYnkMBnQ",
      thumbnail: "https://i.ytimg.com/vi/yLRzYnkMBnQ/hqdefault.jpg",
      category: "food",
      description: "Deliciosa receita com abacaxi"
    },
    {
      title: "Hambúrguer Gourmet",
      url: "https://www.youtube.com/shorts/cXWvs86fyGo",
      thumbnail: "https://i.ytimg.com/vi/cXWvs86fyGo/hqdefault.jpg",
      category: "food",
      description: "Hambúrguer gourmet suculento"
    },
    
    // Dragons
    {
      title: "Dragão de Komodo",
      url: "https://www.youtube.com/shorts/p5yCIlU8Mks",
      thumbnail: "https://i.ytimg.com/vi/p5yCIlU8Mks/hqdefault.jpg",
      category: "dragon",
      description: "O poderoso dragão de Komodo"
    },
    {
      title: "Dragão Barbudo",
      url: "https://www.youtube.com/shorts/sUyBRnZKgHo",
      thumbnail: "https://i.ytimg.com/vi/sUyBRnZKgHo/hqdefault.jpg",
      category: "dragon",
      description: "O fascinante dragão barbudo"
    },
    {
      title: "Dragão Marinho",
      url: "https://www.youtube.com/shorts/fhLr95mQljA",
      thumbnail: "https://i.ytimg.com/vi/fhLr95mQljA/hqdefault.jpg",
      category: "dragon",
      description: "O raro dragão marinho"
    },
    
    // Reino Animal
    {
      title: "Reino Animal - Episódio 1",
      url: "https://www.youtube.com/watch?v=vC1R75jV9JA",
      thumbnail: "https://i.ytimg.com/vi/vC1R75jV9JA/hqdefault.jpg",
      category: "reino-animal",
      description: "Documentário sobre o reino animal"
    },
    {
      title: "Reino Animal - Episódio 2",
      url: "https://www.youtube.com/watch?v=6rFUecTOlV8",
      thumbnail: "https://i.ytimg.com/vi/6rFUecTOlV8/hqdefault.jpg",
      category: "reino-animal",
      description: "Documentário sobre o reino animal"
    },
    {
      title: "Reino Animal - Episódio 3",
      url: "https://www.youtube.com/watch?v=KihLye04VeI",
      thumbnail: "https://i.ytimg.com/vi/KihLye04VeI/hqdefault.jpg",
      category: "reino-animal",
      description: "Documentário sobre o reino animal"
    },
    {
      title: "Reino Animal - Episódio 4",
      url: "https://www.youtube.com/watch?v=PXz8bFfQaqY",
      thumbnail: "https://i.ytimg.com/vi/PXz8bFfQaqY/hqdefault.jpg",
      category: "reino-animal",
      description: "Documentário sobre o reino animal"
    },
    {
      title: "Reino Animal - Episódio 5",
      url: "https://www.youtube.com/watch?v=wLRxJolKSf0",
      thumbnail: "https://i.ytimg.com/vi/wLRxJolKSf0/hqdefault.jpg",
      category: "reino-animal",
      description: "Documentário sobre o reino animal"
    },
    {
      title: "Reino Animal - Episódio 6",
      url: "https://www.youtube.com/watch?v=RJPFkroF7So",
      thumbnail: "https://i.ytimg.com/vi/RJPFkroF7So/hqdefault.jpg",
      category: "reino-animal",
      description: "Documentário sobre o reino animal"
    },
    {
      title: "Reino Animal - Episódio 7",
      url: "https://www.youtube.com/watch?v=BJKOq-eg3uY",
      thumbnail: "https://i.ytimg.com/vi/BJKOq-eg3uY/hqdefault.jpg",
      category: "reino-animal",
      description: "Documentário sobre o reino animal"
    },
    {
      title: "Reino Animal - Episódio 8",
      url: "https://www.youtube.com/watch?v=4mZvl4RVGbw",
      thumbnail: "https://i.ytimg.com/vi/4mZvl4RVGbw/hqdefault.jpg",
      category: "reino-animal",
      description: "Documentário sobre o reino animal"
    },
    {
      title: "Reino Animal - Episódio 9",
      url: "https://www.youtube.com/watch?v=OUycv_CnNMI",
      thumbnail: "https://i.ytimg.com/vi/OUycv_CnNMI/hqdefault.jpg",
      category: "reino-animal",
      description: "Documentário sobre o reino animal"
    },
    {
      title: "Reino Animal - Episódio 10",
      url: "https://www.youtube.com/watch?v=IE2KbC43FAw",
      thumbnail: "https://i.ytimg.com/vi/IE2KbC43FAw/hqdefault.jpg",
      category: "reino-animal",
      description: "Documentário sobre o reino animal"
    },
    {
      title: "Planeta Selvagem",
      url: "https://www.youtube.com/watch?v=-DoVYtE7Mlk",
      thumbnail: "https://i.ytimg.com/vi/-DoVYtE7Mlk/hqdefault.jpg",
      category: "reino-animal",
      description: "Documentário sobre o planeta selvagem"
    },
    {
      title: "Zebras na Savana",
      url: "https://www.youtube.com/shorts/wV2kbN0flWc",
      thumbnail: "https://i.ytimg.com/vi/wV2kbN0flWc/hqdefault.jpg",
      category: "zebra",
      description: "Zebras na savana africana"
    },
  ];
  
  const categories = [
    { id: "all", label: "Todos" },
    { id: "fish", label: "Peixes" },
    { id: "dog", label: "Cães" },
    { id: "butterfly", label: "Borboletas" },
    { id: "owl", label: "Corujas" },
    { id: "hippo", label: "Hipopótamos" },
    { id: "octopus", label: "Polvos" },
    { id: "scorpion", label: "Escorpiões" },
    { id: "rat", label: "Ratos" },
    { id: "zebra", label: "Zebras" },
    { id: "horse", label: "Cavalos" },
    { id: "fox", label: "Raposas" },
    { id: "cat", label: "Gatos" },
    { id: "duck", label: "Patos" },
    { id: "food", label: "Alimentos" },
    { id: "dragon", label: "Dragões" },
    { id: "reino-animal", label: "Reino Animal" },
  ];
  
  const handleWatchVideo = (video: VideoProps) => {
    setActiveVideo(video);
  };
  
  const handleSubscribe = () => {
    toast.success("Inscrição realizada com sucesso! Você será redirecionado para o canal.", {
      duration: 3000,
    });
    setTimeout(() => {
      window.open("https://www.youtube.com/channel/UCYfW1FfL2OZk5u9-GakVKJg", "_blank");
    }, 3000);
  };

  const handlePinterestRedirect = () => {
    window.open("https://br.pinterest.com/crisgride/canal-dos-gatos/", "_blank");
  };

  const handleRumbleRedirect = () => {
    window.open("https://rumble.com/register/FARIAS/", "_blank");
  };

  const handlePlanetaSubscribe = () => {
    window.open("https://rumble.com/c/planetaselvagem6", "_blank");
  };
  
  const formatEmbedUrl = (url: string) => {
    if (url.includes("youtube.com/watch")) {
      return url.replace("watch?v=", "embed/");
    } else if (url.includes("youtube.com/shorts")) {
      return url.replace("shorts/", "embed/");
    } else if (url.includes("youtube.com/live")) {
      return url.replace("live/", "embed/");
    }
    return url;
  };
  
  const renderVideoGrid = (category: string) => {
    const filteredVideos = category === "all" 
      ? videos 
      : videos.filter(video => video.category === category);
    
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {filteredVideos.map((video, index) => (
          <Card key={index} className="overflow-hidden transition-transform hover:scale-105">
            <CardContent className="p-0">
              <div 
                className="aspect-video bg-muted bg-cover bg-center cursor-pointer"
                style={{ backgroundImage: `url(${video.thumbnail || "https://placehold.co/600x400?text=Video"})` }}
                onClick={() => handleWatchVideo(video)}
              >
                <div className="w-full h-full bg-black/30 flex items-center justify-center group hover:bg-black/50 transition-colors">
                  <Button variant="outline" className="bg-primary/80 text-primary-foreground border-none hover:bg-primary group-hover:scale-110 transition-transform">
                    Assistir
                  </Button>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-medium line-clamp-2 mb-2" title={video.title}>{video.title}</h3>
                <p className="text-muted-foreground text-sm line-clamp-2">{video.description}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  };
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow pt-24 pb-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="rounded-lg overflow-hidden mb-8">
            <img
              src="https://storage.googleapis.com/fenado-ai-farm-public/generated/4b6a0669-1e21-45dc-878d-24b32f964718.webp"
              alt="CraftyCreations e Planeta Selvagem"
              className="w-full h-auto object-cover"
            />
          </div>
          
          <div className="flex flex-col md:flex-row gap-6 mb-8">
            <div className="md:w-3/5">
              <h1 className="text-3xl font-bold mb-4">CraftyCreations - Canal de Vídeos de Animais</h1>
              <p className="text-muted-foreground mb-4">
                Bem-vindo ao canal CraftyCreations, onde você encontrará vídeos incríveis sobre a vida selvagem, 
                animais fascinantes e o maravilhoso reino animal. Nosso conteúdo apresenta peixes coloridos, 
                mamíferos impressionantes, aves exóticas e muito mais!
              </p>
              <div className="flex flex-wrap gap-3 mb-6">
                <Button onClick={handleSubscribe} className="bg-red-600 hover:bg-red-700 text-white">
                  Inscrever-se no YouTube
                </Button>
                <Button onClick={handlePlanetaSubscribe} variant="outline" className="border-primary text-primary hover:bg-primary/10">
                  Seguir no Rumble
                </Button>
                <Button onClick={handlePinterestRedirect} variant="outline" className="border-primary text-primary hover:bg-primary/10">
                  Pinterest - Gatos
                </Button>
              </div>
            </div>
            
            <div className="md:w-2/5 bg-card rounded-lg p-6 border border-border">
              <h2 className="text-xl font-semibold mb-4">Canais Relacionados</h2>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">PS</div>
                  <div>
                    <a href="https://studio.youtube.com/channel/UCo-mURMat6Fdqr5X8tZ_v2w" target="_blank" rel="noopener noreferrer" className="font-medium hover:text-primary">
                      Planeta Selvagem 2
                    </a>
                    <p className="text-sm text-muted-foreground">Vídeos sobre o planeta selvagem</p>
                  </div>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">PT</div>
                  <div>
                    <a href="https://studio.youtube.com/channel/UCo-mURMat6Fdqr5X8tZ_v2w" target="_blank" rel="noopener noreferrer" className="font-medium hover:text-primary">
                      Planeta Terra Chamando
                    </a>
                    <p className="text-sm text-muted-foreground">Vídeos sobre nosso planeta</p>
                  </div>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">PS</div>
                  <div>
                    <a href="https://rumble.com/c/planetaselvagem6" target="_blank" rel="noopener noreferrer" className="font-medium hover:text-primary">
                      Planeta Selvagem 6 (Rumble)
                    </a>
                    <p className="text-sm text-muted-foreground">Nosso canal no Rumble</p>
                  </div>
                </li>
              </ul>
              
              <Separator className="my-4" />
              
              <h3 className="text-lg font-medium mb-3">Criar conta no Rumble</h3>
              <p className="text-sm text-muted-foreground mb-3">
                Crie sua conta no Rumble e acompanhe nossos vídeos também nessa plataforma.
              </p>
              <Button onClick={handleRumbleRedirect} className="w-full">
                Registrar no Rumble
              </Button>
            </div>
          </div>
          
          <Tabs defaultValue="all" className="w-full">
            <div className="overflow-x-auto pb-2">
              <TabsList className="mb-6">
                {categories.map((category) => (
                  <TabsTrigger key={category.id} value={category.id}>
                    {category.label}
                  </TabsTrigger>
                ))}
              </TabsList>
            </div>
            
            {categories.map((category) => (
              <TabsContent key={category.id} value={category.id} className="mt-0">
                {renderVideoGrid(category.id)}
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </main>
      
      <Dialog open={!!activeVideo} onOpenChange={(open) => !open && setActiveVideo(null)}>
        <DialogContent className="sm:max-w-4xl">
          <DialogHeader>
            <DialogTitle>{activeVideo?.title}</DialogTitle>
          </DialogHeader>
          <div className="aspect-video w-full">
            <iframe 
              src={activeVideo ? formatEmbedUrl(activeVideo.url) : ""} 
              className="w-full h-full" 
              allowFullScreen 
              title={activeVideo?.title}
            ></iframe>
          </div>
          <p className="text-muted-foreground">{activeVideo?.description}</p>
          <div className="flex justify-between">
            <Button onClick={handleSubscribe} className="bg-red-600 hover:bg-red-700 text-white">
              Inscrever-se no Canal
            </Button>
            <Button variant="outline" onClick={() => setActiveVideo(null)}>
              Fechar
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      
      <Footer />
    </div>
  );
};

export default CraftyCreationsPage;